// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_ZVt","label":"styles_label__YtAdk"};